module.exports = "/fonts/vendor/vue-img-inputer/dist/iconfont.eot?084ac6db7bba4875d38bef0d32257558";